<template>
    <b-modal
        v-model="showPopup"
        size="xxl"
        id="customModal"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <M3Amanare :sfat="false"></M3Amanare>
            <M3AmanareRecomandare></M3AmanareRecomandare>
        </div>
    </b-modal>
</template>

<script>
    import {BModal} from 'bootstrap-vue';
    import M3Amanare from '@/pages/Aplicatii/M3/M3Status/components/M3Amanare'
    import M3AmanareRecomandare from '@/pages/Aplicatii/M3/M3Status/components/M3AmanareRecomandare'
    export default {
        components: {
            BModal,
            M3Amanare,
            M3AmanareRecomandare
        },
        props: {
            showPopup: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                }
            },
        },
    };
</script>

<style>
#customModal .modal-body{
    padding: 0;
}
</style>
<style scoped>
.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
}
.close-button{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.button-confirm{
    color: #fff;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    padding: 5px 10px;
    width: 50%;
}
.button-confirm:hover{
    background: #fff;
    color: #000;
    cursor: pointer;
}
.v-select{
    width: 100%;
    margin: 15px 0;
}
.v-select >>> .vs__dropdown-toggle{
    margin: 0;
    background: transparent;
    border: 1px solid #fff;
    border-radius: 4px;
    width: 100%;
    min-width: 170px;
    padding: 2px;
}
.v-select >>> .vs__selected-options{
    font-size: 14px;
    color: #fff;
    flex-wrap: inherit !important;
    max-height: 35px;
    overflow: hidden;
    align-items: flex-start;
}
.v-select >>> .vs__selected{
    margin: 0;
    padding: 0;
    color: #fff;
}
.v-select >>> .vs__actions{
    padding: 0;
    transform: scale(0.65);
}
.v-select >>> .vs__actions svg{
    color: #fff;
    fill: #fff;
}
.v-select >>> .vs__dropdown-menu{
    background: #343a40;
    font-size: 12px;
}
.v-select >>> .vs__dropdown-option{
    color: #fff;
}
.v-select >>> .vs__dropdown-option:hover{
    background: #545a6f;
}
.v-select >>> .vs__selected-options input{
    color: #fff;
}
.white-icon{
    color: #fff;
    margin-bottom: 20px;
}
</style>